import {
  ExternalReportFiltersModelInterface,
  GenerateContractsReportFiltersInterface,
  IPaginatorData,
  ReportFiltersListModelInterface,
  ReportsFiltersListQueryInterface,
  UpdateReportsFiltersInterface,
} from '@elearning-platform/api-types/interfaces';
import { stringify } from 'query-string';

import { api } from '../api';

export const getReportsFilters: (params: ReportsFiltersListQueryInterface) => Promise<IPaginatorData<ReportFiltersListModelInterface>>
  = (params: ReportsFiltersListQueryInterface): Promise<IPaginatorData<ReportFiltersListModelInterface>> => api.get(
    `reports/filters?${stringify(params, { skipEmptyString: true })}`
  );

export const getReportFilters: (id: number) => Promise<ExternalReportFiltersModelInterface>
  = (id: number): Promise<ExternalReportFiltersModelInterface> => api.get(
    `reports/filters/${id}`
  );

export const generateReportBySavedFilters: (id: number) => Promise<void>
  = (id: number): Promise<void> => api.get(
    `reports/${id}`, { responseType: 'blob' }
  );

export const deleteReportFilters: (id: number) => Promise<void>
  = (id: number): Promise<void> => api.delete(
    `reports/filters/${id}`
  );

export const createReportFilters: (data: UpdateReportsFiltersInterface) => Promise<ExternalReportFiltersModelInterface>
  = (data: UpdateReportsFiltersInterface): Promise<ExternalReportFiltersModelInterface> => api.post(
    'reports/filters', data
  );

export const updateReportFilters: (id: number, data: UpdateReportsFiltersInterface) => Promise<ExternalReportFiltersModelInterface>
  = (id: number, data: UpdateReportsFiltersInterface): Promise<ExternalReportFiltersModelInterface> => api.post(
    `reports/filters/${id}`, data
  );

export const generateReport: (data: GenerateContractsReportFiltersInterface) => Promise<void>
  = (data: GenerateContractsReportFiltersInterface): Promise<void> => api.post(
    'reports', data, { responseType: 'blob' }
  );
